{
  "footer": {
    "text": {
      "imprint": "Otisk",
      "privacy-policy": "Zásady ochrany osobních údajů",
      "powered": "Powered by Lumxi GmbH"
    }
  }
}
